module.exports = __webpack_public_path__ + "static/img/sign-btn-bg.9b47e88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign-btn-bg.png
// module id = SCzQ
// module chunks = 0